import React from "react";
import FormField from "../shared/TextField/FormField";
import { UserProviderProfile } from "../../recoil/types";
import { formatPhoneNumber } from "../../utils/helpers";
import {
  FieldRow,
  GeneralInfoText,
  GeneralInfoWrapper,
} from "./Profile.styles";

const AccountDetails: React.FC<{ profileInfo: UserProviderProfile }> = ({
  profileInfo,
}) => (
  <GeneralInfoWrapper>
    <GeneralInfoText>MY ACCOUNT</GeneralInfoText>
    <FieldRow>
      <FormField
        styles={{ borderTop: "1px solid #e7ebf2" }}
        fieldTitle="Account Name"
        fieldValue={profileInfo.account.sfname || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="Unity samples"
        fieldValue={(profileInfo.account.unity_samples || 0).toString()}
      />
      <FormField
        fieldTitle="Phone"
        fieldValue={formatPhoneNumber(profileInfo.account.phone || "") || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="Secondary phone"
        fieldValue={formatPhoneNumber(profileInfo.account.phone || "") || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="Type"
        fieldValue={profileInfo.account.type || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="LIMS ID"
        fieldValue={profileInfo.account.lims_id || "-"}
      />
      <FormField
        fieldTitle="Office fax"
        fieldValue={profileInfo.account.office_fax || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="Phlebotomy"
        fieldValue={profileInfo.account.phlebotomy_solution || "-"}
      />
    </FieldRow>
    <FieldRow>
      <FormField
        fieldTitle="Billing address"
        fieldValue={
          profileInfo.account.billingstreet
            ? `${profileInfo.account.billingstreet}, ${profileInfo.account.billingcity}, ${profileInfo.account.billingstate} ${profileInfo.account.billingpostalcode}`
            : ""
        }
      />
    </FieldRow>
  </GeneralInfoWrapper>
);

export default AccountDetails;
